__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "clientCommon_mf";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(621), __webpack_require__.e(137)]).then(() => (() => (__webpack_require__(2621))))));
			register("@splidejs/react-splide", "0.7.12", () => (Promise.all([__webpack_require__.e(296), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(296))))));
			register("@splidejs/splide-extension-auto-scroll", "0.5.3", () => (__webpack_require__.e(145).then(() => (() => (__webpack_require__(9145))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(854))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(139).then(() => (() => (__webpack_require__(8139))))));
			register("intl", "1.2.5", () => (Promise.all([__webpack_require__.e(731), __webpack_require__.e(905)]).then(() => (() => (__webpack_require__(4731))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(3536))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-intl", "5.25.1", () => (Promise.all([__webpack_require__.e(986), __webpack_require__.e(99), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(4099))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(508), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(7508))))));
			register("react-router-dom", "6.29.0", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(475), __webpack_require__.e(656), __webpack_require__.e(686), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(5475))))));
			register("react-router", "6.29.0", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(216), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(3216))))));
			register("react-slick", "0.30.3", () => (Promise.all([__webpack_require__.e(382), __webpack_require__.e(656), __webpack_require__.e(32)]).then(() => (() => (__webpack_require__(2382))))));
			register("react-toastify", "8.2.0", () => (Promise.all([__webpack_require__.e(628), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(9628))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("redux-dynamic-modules-saga", "5.2.3", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(137), __webpack_require__.e(109)]).then(() => (() => (__webpack_require__(5109))))));
			register("redux-dynamic-modules", "5.2.3", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(656), __webpack_require__.e(137), __webpack_require__.e(534), __webpack_require__.e(622)]).then(() => (() => (__webpack_require__(4622))))));
			register("redux-saga", "1.3.0", () => (Promise.all([__webpack_require__.e(359), __webpack_require__.e(498)]).then(() => (() => (__webpack_require__(2498))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(805).then(() => (() => (__webpack_require__(805))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};